import React from 'react';
import {Spin, Modal, message} from 'antd';
import _ from 'lodash';

import {WeaLocaleProvider, WeaTools, WeaBrowser} from 'ecCom';
import ReactGridLayout from './react-grid-layout/ReactGridLayout';
import WeaPortalShare from '../wea-portal-share';

import Element from './Element';

const getLabel = WeaLocaleProvider.getLabel;

class GridLayout extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.getLayout = this.getLayout.bind(this);
        this.onAddElement = this.onAddElement.bind(this);
        this.onEditElement = this.onEditElement.bind(this);
        this.onDeleteElement = this.onDeleteElement.bind(this);
        this.onLayoutChange = this.onLayoutChange.bind(this);
        this.getElements = this.getElements.bind(this);
    }

    componentWillMount() {
        const {elements = []} = this.props;
        this.getLayout(elements);
    }

    componentWillReceiveProps(nextProps) {
        const {elements = []} = nextProps;
        this.getLayout(elements);
    }

    render() {
        const {isSetting, layoutType, width, height, layout: layoutConf = {}} = this.props;
        const {verticalAlign, cellCols, cellHeight, cellMarginX, cellMarginY} = layoutConf;
        const {loading = false, elements = [], layout = []} = this.state;

        return (
            <Spin spinning={loading}>
                <ReactGridLayout
                    width={width}
                    height={height}
                    verticalAlign={verticalAlign}
                    cols={cellCols}
                    draggableCancel=".wea-portal-layout-element-toolbar"
                    draggableHandle=".wea-portal-layout-element-header"
                    rowHeight={cellHeight}
                    isDraggable={isSetting}
                    isResizable={isSetting}
                    margin={[cellMarginX, cellMarginY]}
                    layout={layout}
                    onLayoutChange={this.onLayoutChange}
                    onDragStop={() => window.WeaPortalLayoutIsChanged = true}
                    onResizeStop={() => window.WeaPortalLayoutIsChanged = true}
                >
                    {
                        elements.map((item) => {
                            return (
                                <div key={item.i} data-grid={item} className="wea-portal-layout-element">
                                    {
                                        isSetting && (
                                            <div className="wea-portal-layout-element-header">
                                                <div className="wea-portal-layout-element-toolbar">
                                                    {
                                                        layoutType === 'theme' && (
                                                            <WeaPortalShare title={getLabel(82752, '共享范围')} type={{element: item.id}}>
                                                                <i className="icon-coms-Batch-sharing" title={getLabel(119, '共享')}/>
                                                            </WeaPortalShare>
                                                        )
                                                    }
                                                    <WeaBrowser
                                                        type="devmodules"
                                                        comType={layoutType === 'theme' ? 'portalComElement' : 'portalComLoginElement'}
                                                        isSingle={false}
                                                        customized
                                                        onChange={(ids, names, datas) => this.onEditElement(item.id, datas)}
                                                    >
                                                        <i className="icon-coms-edit" title={getLabel(26473, '编辑')}/>
                                                    </WeaBrowser>
                                                    <i className="icon-coms-Clear" onClick={() => this.onEditElement(item.id)} title={getLabel(311, '清除')}/>
                                                    <i className="icon-coms-delete" title={getLabel(91, '删除')} onClick={() => this.onDeleteElement(item.i, item.id)}/>
                                                </div>
                                            </div>
                                        )
                                    }
                                    <div className="wea-portal-layout-element-content">
                                        <Element {...this.props} isSetting={isSetting} item={item}/>
                                    </div>
                                </div>
                            );
                        })
                    }
                </ReactGridLayout>
            </Spin>
        );
    }

    getLayout(elements = []) {
        const _elements = elements.map((item) => {
            return {
                i: String(item.id),
                x: item.x,
                y: item.y,
                w: item.w || item.width,
                h: item.h || item.height,
                width: item.w || item.width,
                height: item.h || item.height,
                id: item.id,
                content: item.content
            }
        });

        this.setState({
            elements: _elements,
            layout: _.cloneDeep(_elements)
        });
    }

    onAddElement(id, position) {
        const {loading, elements, layout} = this.state;

        if (loading) {
            return;
        }

        let maxX = 0, leftX, maxY = 0, bottomY;
        // for (let i = 0, len = layout.length; i < len; i++) {
        //     leftX = layout[i].x + layout[i].w;
        //     if (leftX > maxX) maxX = leftX;
        // }
        for (let i = 0, len = layout.length; i < len; i++) {
            bottomY = layout[i].y + layout[i].h;
            if (bottomY > maxY) maxY = bottomY;
        }

        let width = 6;
        let height = 6;

        if (position === 'top') {
            width = 4;
            height = 4;
        } if (position === 'bottom') {
            width = 4;
            height = 2;
        } else if (position === 'left' || position === 'right') {
            width = 2;
            height = 8;
        }

        const element = {x: maxX, y: maxY, w: width, h: height, width, height};

        this.setState({loading: true});
        WeaTools.callApi('/api/portal/portalGridLayout/editPortalGridLayoutElement', 'POST', {
            layoutId: id,
            layoutPosition: position,
            layoutElement: JSON.stringify(element)
        }).then((result) => {
            const {data = {}} = result;
            const {id} = data;

            elements.push({...element, i: String(id), id});
            layout.push({...element, i: String(id), id});

            this.setState({
                loading: false,
                elements: elements,
                layout: layout
            });
            window.WeaPortalLayoutIsChanged = true;
        });
    }

    onEditElement(id, datas) {
        const {elements} = this.state;
        let content = {};

        if (datas && datas.length) {
            const {parent: id, parentName: module, name: component, title} = datas[0];
            content = {id, module, component, title};
        }

        for (let i = 0, len = elements.length; i < len; i++) {
            const item = elements[i];
            if (item.id === id) {
                item.content = content;
            }
        }

        this.setState({elements});
        window.WeaPortalLayoutIsChanged = true;
    }

    onDeleteElement(index, id) {
        const {elements, layout} = this.state;
        const _elements = [];
        const _layout = [];

        Modal.confirm({
            title: getLabel(15172, '系统提示'),
            content: getLabel(15097, '确定要删除吗？'),
            onOk: () => {
                WeaTools.callApi('/api/portal/portalGridLayout/deletePortalGridLayoutElement', 'GET', {ids: id});

                for (let i = 0, len = elements.length; i < len; i++) {
                    const item = elements[i];
                    if (item.i !== index) {
                        _elements.push(item);
                    }
                }

                for (let i = 0, len = layout.length; i < len; i++) {
                    const item = layout[i];
                    if (item.i !== index) {
                        _layout.push(item);
                    }
                }

                this.setState({
                    elements: _elements,
                    layout: _layout
                });
                window.WeaPortalLayoutIsChanged = true;
            }
        });
    }

    onLayoutChange(layout) {
        this.setState({layout});
    }

    getElements() {
        const {elements, layout} = this.state;
        const _elements = [];

        for (let i = 0, len = elements.length; i < len; i++) {
            const item = elements[i];
            for (let j = 0, len2 = layout.length; j < len2; j++) {
                const item2 = layout[j];
                if (item.i === item2.i) {
                    _elements.push({...item, ...item2});
                }
            }
        }

        return _elements;
    }
}

export default GridLayout;


// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4public/wea-portal-layout/GridLayout.js